import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useDocumentTitle = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const getTitleByPath = (): string => {
        return t('titles.app_name', { ns: 'common' });
    };

    const title = getTitleByPath();
    document.title = title;
  }, [t]);

}; 